module.exports = __webpack_public_path__ + "img/tab2.54876c1b.png";